// 兌換商品 資訊

import ItemTags from '@/components/item/ItemTags'; // 商品標籤
import ItemDesc from '@/components/item/ItemDesc'; // 商品描述
import ItemExchangeButton from '@/components/item/ItemExchangeButton'; // 兌換按鈕

interface Props {
    item?: any;
    isDisabled: boolean;
    buttonLabel: string;
}

const ExchangeItemInfo = ({ item = {}, isDisabled = false, buttonLabel }: Props) => {
    const { name = '', shortDesc, type, categoryName = '' } = item || {};

    return (
        <div className="space-y-5.5">
            {/* 商品標籤 */}
            <ItemTags type={type} categoryName={categoryName} />

            {/* 商品名稱 */}
            <h2 className="text-h3 text-black9">{name}</h2>

            {/* 商品描述 */}
            <ItemDesc shortDesc={shortDesc} />

            {/* 兌換按鈕 */}
            <ItemExchangeButton item={item} isDisabled={isDisabled} buttonLabel={buttonLabel} />
        </div>
    );
};

export default ExchangeItemInfo;
